"use client";

import { CustomIcon } from "@/components/custom/icons/custom-icon";
import { Typography } from "@/components/custom/typography";
import { Tooltip, TooltipTrigger } from "@/components/ui/tooltip";
import { TooltipContent } from "@radix-ui/react-tooltip";
import { redirect } from "next/navigation";
import { useTypedTranslations } from "@/i18n/typed";

export function AIChatHistories() {
  const t = useTypedTranslations("searchAIChat");

  return (
    <div className="bg-gray-200 p-2">
      <Typography as="span" variant="body3" className="text-gray-700">
        {t("history.guestNotice")}{" "}
        <Typography
          as="span"
          className="underline cursor-pointer"
          onClick={() => redirect("/user/select-member-type")}
        >
          {t("history.signup")}
        </Typography>{" "}
        {t("history.guestNoticeSuffix")}
      </Typography>

      <div className="inline-flex gap-1 mt-1">
        <Tooltip>
          <TooltipTrigger asChild>
            <CustomIcon name="InfoCircle" size={5} />
          </TooltipTrigger>

          <TooltipContent side="bottom" align="start" sideOffset={4}>
            <div className="max-w-80 bg-white p-2 rounded-md shadow-md">
              <Typography
                as="p"
                variant="subheading3"
                className="text-gray-600"
              >
                {t("history.policyTitle")}
              </Typography>
              <Typography as="span" className="text-xs">
                {t("history.policyContent")}
              </Typography>
            </div>
          </TooltipContent>
        </Tooltip>

        <Typography as="span" variant="body3" className="text-gray-500">
          {t("history.policyQuestion")}
        </Typography>
      </div>
    </div>
  );
}
